import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './app-input.component.html',
  styleUrls: ['./app-input.component.scss'],
})
export class AppInputComponent {
  @Input() inputFormControl: FormControl = new FormControl('');
  @Input() placeholder: string;
  @Input() label: string;
  @Input() type: string = 'text';

  constructor() {}

  showErrorMessage() {
    return this.hasErrorMessage() && this.inputFormControl?.touched;
  }

  hasErrorMessage(): boolean {
    return !!this.inputFormControl && !!this.inputFormControl.errors;
  }
}
